/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./issue.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./issue.component";
var styles_IssueComponent = [i0.styles];
var RenderType_IssueComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_IssueComponent, data: {} });
export { RenderType_IssueComponent as RenderType_IssueComponent };
export function View_IssueComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" issue works!\n"]))], null, null); }
export function View_IssueComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-issue", [], null, null, null, View_IssueComponent_0, RenderType_IssueComponent)), i1.ɵdid(1, 114688, null, 0, i2.IssueComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var IssueComponentNgFactory = i1.ɵccf("app-issue", i2.IssueComponent, View_IssueComponent_Host_0, {}, {}, []);
export { IssueComponentNgFactory as IssueComponentNgFactory };
